// extracted by mini-css-extract-plugin
export default {"longWaitTimer":"TaaAk9ChR4k30rhLkAGH"};